import React from "react";

interface Props {
  rows: object[];
}

const FooterColumnContent: React.FC<Props> = (props: Props) => {
  const { rows } = props;
  return (
    <div>
      <div className="footer-content-wrapper">
        {rows.map((row: any, index: number) => {
          return (
            <div
              key={row.title}
              data-test-footer-content
              className="footer-content"
            >
              <a href={row.url}>{row.title}</a>
            </div>
          );
        })}
      </div>
      <div className="footer-border"> </div>
    </div>
  );
};

export default FooterColumnContent;
